import { createClient } from '@supabase/supabase-js'

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY

// Determinar la URL de redirección según el entorno
const getRedirectUrl = () => {
  // En producción, usar la URL de Cloudflare Pages
  if (window.location.hostname.includes('pages.dev') || window.location.hostname.includes('motorvault')) {
    return 'https://motorvault.pages.dev'
  }
  // En desarrollo, usar localhost
  return 'http://localhost:3000'
}

// Verificar que les variables d'entorn estiguin configurades
export const isSupabaseConfigured = () => {
  return !!(supabaseUrl && supabaseAnonKey && supabaseUrl !== 'your-supabase-url' && supabaseAnonKey !== 'your-supabase-anon-key')
}

// Crear el client de Supabase només si està configurat
export const supabase = isSupabaseConfigured()
  ? createClient(supabaseUrl, supabaseAnonKey, {
      auth: {
        persistSession: true,
        autoRefreshToken: true,
        detectSessionInUrl: true,
        redirectTo: getRedirectUrl(),
      },
      global: {
        headers: {
          'x-client-info': 'motorvault-web',
        },
      },
      db: {
        schema: 'public',
      },
    })
  : null

// Logging per debug
if (isSupabaseConfigured()) {
  console.log('✅ Supabase client inicializado correctamente')
} else {
  console.warn('⚠️ Supabase no está configurado. Variables de entorno faltantes.')
}
